import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { HotelStars } from '@lt/components';

import { useTranslation } from '@lt/localization';
import ReviewsList from '../../containers/Reviews/ReviewsList';
import Breadcrumbs from '../Breadcrumbs';

const baseCls = 'lt-hotel-reviews';

const ReviewsMobile = ({ breadcrumbs, stars, hotelName }) => {
  const { t } = useTranslation();
  return (
    <div>
      <StyledHeaderContainer>
        <StyledStarsContainer>
          <HotelStars value={stars} />
          <StyledBreadcrumbs items={breadcrumbs} fadeColor="#f3f3f3" />
        </StyledStarsContainer>
        <StyledHeader>
          {`${t('hotel.reviews.title')} `}
          <StyledHotelName>{hotelName}</StyledHotelName>
        </StyledHeader>
      </StyledHeaderContainer>
      <div className={`${baseCls}__items`}>
        <ReviewsList />
      </div>
    </div>
  );
};

const StyledHeaderContainer = styled.div`
  margin-bottom: 10px;
  padding: 0 10px;
`;

const StyledHeader = styled.h2`
  ${(props) => props.theme.typography.headline3}
  font-weight: normal;
`;

const StyledHotelName = styled.strong`
  font-weight: bold;
`;

const StyledStarsContainer = styled.div`
  margin-bottom: 8px;
  display: flex;
`;

const StyledBreadcrumbs = styled(Breadcrumbs)`
  ${(props) => props.theme.typography.t2s}
  margin-left: 5px;
  width: 100%;
`;

ReviewsMobile.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      title: PropTypes.string.isRequired,
    }),
  ).isRequired,
  hotelName: PropTypes.string.isRequired,
  stars: PropTypes.number.isRequired,
};

export default ReviewsMobile;
